import { makeStyles } from '@material-ui/core';

const styles = makeStyles((_theme) => ({
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
  },
  closeBnt: {
    width: 35,
    height: 35,
    alignSelf: 'flex-end',
    textTransform: 'none',
  },
  backBnt: {
    textTransform: 'none',
  },
  box: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  input: {
    marginTop: 10,
  },
  rsuSelect: {
    marginTop: 16,
    marginBottom: 8,
  },
  submitButton: {
    marginTop: 20,
  },
}));

export default styles;
